(() => {
  if (typeof window.customElements.get('locations-section') !== 'undefined') { return }
  window.customElements.define('locations-section', class LocationsSection extends HTMLElement { // eslint-disable-line
    constructor() {
      super()
      this.list = this.querySelector('[data-locations-list]')
      this.listWrapper = this.querySelector('[data-locations-list-wrapper]')
      this.mapEl = this.querySelector('[data-locations-map]')
      this.mapWrapper = this.querySelector('[data-locations-map-wrapper]')
      this.toggleLists = this.querySelectorAll('[data-toggle-list]')
      this.toggleMaps = this.querySelectorAll('[data-toggle-map]')
      this.resultsCount = this.querySelector('[data-results-count]')
      this.submit = this.querySelector('[data-locations-submit]')
      this.form = this.querySelector('[data-locations-form]')
      this.input = this.querySelector('[data-locations-input]')
      // this.consortiumFilter = this.querySelector('[data-locations-filter]')
      // this.consortiumCheckboxes = this.querySelectorAll('[data-consortium-checkbox]')
      // this.manulifeToggle = this.querySelector('[data-manulife-toggle]')
      // this.manulifeLabelEl = this.querySelector('[data-label-manulife]')
      // this.manulifeCheckbox = this.querySelector('[data-manulife-checkbox]')
      // this.manulifeLocationIds = []
      // const utmSource = new URLSearchParams(window.location.search).get('utm_source') || ''
      // this.isManulife = utmSource.includes('manulife')
      // this.utmSource = utmSource
      this.clickTime = Date.now() - 1001
      // Visique clinic externalIds that should NOT show a booking button (e.g., merged/closed clinics).
      // Add more IDs to this array to hide additional Visique locations from booking.
      this.visiqueHiddenBookingIds = ['508']
      this.allLocations = []
      this.markers = []
      this.map = null
      this.range = 50000
      this.autocomplete = null
      this.infowindow = null
      this.defaultAddress = window.locations.default_location
      this.loc = []
      this.attempts = 0
      this.prefLocation = 0
      this.initToggles()
      // this.initManulifeToggle()
      this.init()
      this.checkToken()
    }

    async init() {
      this.allLocations = await this.getLocations();
      if (!this.allLocations) { return }

      await this.initMap()
      this.renderMarkers()
      this.renderListLocation()
      this.getLocation()

      if (localStorage.getItem('mapsPlace')) {
        const mapsPlace = JSON.parse(localStorage.getItem('mapsPlace'))
        this.updateCenter(mapsPlace)
        this.input.value = mapsPlace.name
        localStorage.removeItem('mapsPlace')
      }

      this.autocomplete = new google.maps.places.Autocomplete(this.input);
      this.autocomplete.setComponentRestrictions({ country: ['ca'] });
      this.autocomplete.addListener('place_changed', this.updateCenter.bind(this));

      this.form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.submitInput()
      })

      // this.consortiumCheckboxes.forEach(checkbox => {
      //   checkbox.addEventListener('change', () => {
      //     this.renderMarkers()
      //     this.renderListLocation()
      //   })
      // })
    }

    submitInput() {
      if (!this.input.value || this.input.value === '') { return }
      this.updateCenter()

      this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
      this.autocompleteService = new google.maps.places.AutocompleteService();

      const request = {
        input: this.input.value,
        componentRestrictions: {
          country: 'ca'
        }
      }

      this.autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status !== 'OK') { console.error('Autocomplete request failed with status: ' + status) }

        this.placesService.getDetails({ placeId: predictions[0].place_id }, (place, detailStatus) => {
          if (detailStatus !== google.maps.places.PlacesServiceStatus.OK) { return }
          this.updateCenter(place)
        });
      })
    }

    // async initManulifeToggle() {
    //   if (this.utmSource && !this.isManulife) {
    //     try {
    //       const res = await fetch(`${window.locations.api_url}/insurance-companies`, {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ utmSource: this.utmSource })
    //       })
    //       const data = await res.json()
    //       if (data && typeof data === 'object') {
    //         this.consortiumFilter.classList.remove('hide')
    //       }
    //     } catch (e) {
    //       console.error('Failed to load insurance companies:', e)
    //     }
    //     return
    //   }
    //
    //   if (!this.isManulife) { return }
    //
    //   try {
    //     const res = await fetch(window.locations.location_ids_csv_url)
    //     const csv = await res.text()
    //     this.manulifeLocationIds = csv.split('\n')
    //       .slice(1)
    //       .map(line => line.trim())
    //       .filter(line => line !== '')
    //   } catch (e) {
    //     console.error('Failed to load manulife location IDs:', e)
    //     return
    //   }
    //
    //   this.manulifeLabelEl?.classList.remove('hide')
    //   this.consortiumFilter.classList.remove('hide')
    //   this.manulifeToggle.classList.remove('hide')
    //   this.manulifeCheckbox.checked = true
    //   this.manulifeCheckbox.addEventListener('change', () => {
    //     this.renderMarkers()
    //     this.renderListLocation()
    //   })
    // }

    initToggles() {
      this.toggleLists.forEach(toggleList => {
        toggleList.addEventListener('click', () => {
          this.toggleElements('list')
        })
      })

      this.toggleMaps.forEach(toggleMap => {
        toggleMap.addEventListener('click', () => {
          this.toggleElements('map')
        })
      })
    }

    toggleElements(type) {
      this.toggleLists.forEach(toggleList => {
        toggleList.classList.toggle('hide', type === 'list')
      })
      this.toggleMaps.forEach(toggleMap => {
        toggleMap.classList.toggle('hide', type === 'map')
      })
      this.listWrapper.classList.toggle('active', type === 'list')
      this.mapWrapper.classList.toggle('active', type === 'map')
    }

    checkToken() {
      if (!window.locations.is_customer) { return }

      const tokenString = localStorage.getItem('LRTokenKey')
      if (tokenString) {
        this.fetchPreferedClinic(tokenString)
      } else if (!tokenString && this.attempts < 10) {
        this.attempts++
        setTimeout(this.checkToken, 300)
      }
    }

    async fetchPreferedClinic(tokenString) {
      if (!localStorage.getItem('pc') || localStorage.getItem('pc') == 'undefined') {
        await fetch(`${window.locations.api_url}/customer/preferred-clinic`, {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + tokenString,
          }
        })
          .then(response => {
            if (response.status === 200) {
              return response.json();
            } else {
              return null;
            }
          })
          .then(data => {
            if (!data) { return }
            this.prefLocation = JSON.parse(data.locationId);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.prefLocation = localStorage.getItem('pc');
      }
    }

    async getLocations() {
      try {
        const baseUrl = `${window.locations.api_url}/locations/paginated?lang=${window.locations.language}&NbPerPage=200`;

        const firstResponse = await fetch(`${baseUrl}&PageNb=1`);
        if (!firstResponse.ok) {
          throw new Error('Failed to fetch locations');
        }
        const firstData = await firstResponse.json();
        let allResults = firstData.results;

        if (firstData.totalPages > 1) {
          const remainingPages = Array.from({ length: firstData.totalPages - 1 }, (_, i) => i + 2);
          const responses = await Promise.all(
            remainingPages.map(pageNb => fetch(`${baseUrl}&PageNb=${pageNb}`).then(res => {
              if (!res.ok) throw new Error('Failed to fetch locations');
              return res.json();
            }))
          );
          responses.forEach(data => { allResults = allResults.concat(data.results); });
        }

        // TODO: Temporary hard-coded coordinates for BonLook locations until the API returns lat/lng
        if (window.location.hostname.includes('web.uat.fyidoctors.com')) {
          const coordinateOverrides = {
            4531: { latitude: 48.4279, longitude: -71.0550 },  // Chicoutimi - Place du Royaume
            4532: { latitude: 45.3783, longitude: -71.8465 },  // Sherbrooke - 3050 boul de Portland
            4533: { latitude: 46.7812, longitude: -71.2768 },  // Québec - 2450 Boul Laurier
            4534: { latitude: 45.4765, longitude: -75.7013 },  // Gatineau - 1100 Boul Maloney Ouest
            4535: { latitude: 45.5032, longitude: -73.5735 },  // Montréal - 677 Sainte-Catherine Ouest
            4536: { latitude: 45.5245, longitude: -73.6005 },  // Montréal - 257 Saint-Viateur Ouest
            4537: { latitude: 45.4835, longitude: -73.5815 },  // Montréal - 2440 Notre-Dame Ouest
            604: { latitude: 45.4451, longitude: -73.4692 },  // Brossard - 100 Prom des Lanternes
            605: { latitude: 45.5025, longitude: -73.5725 },  // Montréal - 1500 McGill College
            606: { latitude: 45.5840, longitude: -73.5430 },  // Montréal - 7999 boul des Galeries-d'Anjou
            607: { latitude: 46.3575, longitude: -72.5742 },  // Trois-Rivières - 4225 boul des Forges
          }
          allResults.forEach(location => {
            if (coordinateOverrides[location.externalId]) {
              if (!location.latitude && !location.longitude) {
                location.latitude = coordinateOverrides[location.externalId].latitude
                location.longitude = coordinateOverrides[location.externalId].longitude
              }
              if (!location.name) {
                location.name = 'BonLook'
              }
            }
          })
        }

        return allResults.filter(location => location.status?.toLowerCase().includes('closed') === false);
      } catch (error) {
        console.error(error);
      }
    }

    getLocation() {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state == 'granted' || result.state == 'prompt') {
          navigator.geolocation.getCurrentPosition(this.setPosition.bind(this), this.setPosition.bind(this), {
            enableHighAccuracy: false,
            maximumAge: 30000,
            timeout: 20000
          });
        } else {
          this.report(result.state);
          this.renderListLocation()
          this.renderMarkers()
        }
        result.onchange = () => {
          this.report(result.state)
        }
      });
    }

    report(state) {
      console.log('Permission: ' + state);
    }

    updateCenter(data = this.autocomplete?.getPlace()) {
      this.loc = (data && data.geometry) ? {
        lat: data.geometry.location.lat(),
        lng: data.geometry.location.lng()
      } : this.defaultAddess
      this.toggleElements('map')
      this.map.panTo(data.geometry.location)
      this.renderMarkers()
      this.renderListLocation()
    }

    setPosition(geolocationPosition) {
      if (geolocationPosition.coords) {
        localStorage.setItem('geoperm', 'true')
        this.loc = {
          lat: geolocationPosition.coords.latitude,
          lng: geolocationPosition.coords.longitude
        }
        this.defaultAddess = this.loc
      } else {
        localStorage.setItem('geoperm', 'false')
      }
      this.customerLocation = this.loc;
      this.map.setCenter(this.loc);
      this.renderListLocation()
      this.renderMarkers()
    }

    renderMarkers() {
      this.markers.forEach(marker => marker.setMap(null))
      this.markers = []
      const locations = this.filterLocations()
      locations.forEach(item => {
        const marker = new google.maps.Marker({
          position: {
            lat: item.latitude,
            lng: item.longitude
          },
          icon: window.locations.marker_svg_url,
          map: this.map
        })
        google.maps.event.addListener(marker, 'click', ((marker, item) => {
          return () => {
            if (this.infowindow) {
              this.infowindow.close()
            }
            this.infowindow = new google.maps.InfoWindow()
            const infoWindowContent = `
              <div class="location-popup">
                <div class="location__header">
                  ${this.renderTitle(item)}
                </div>
                ${this.renderSpecialties(item)}
                <div class="location__meta">
                  ${this.renderPhone(item)}
                  ${this.renderAddress(item)}
                </div>
                ${this.renderPreferredClinic(item)}
                ${this.renderMakePreferred(item)}
                <div class="location__actions">
                  ${this.renderBookingButton(item)}
                  ${this.renderDetailsButton(item)}
                </div>
              </div>
            `
            this.infowindow.setContent(infoWindowContent);
            this.infowindow.open(this.map, marker);
            this.clickTime = Date.now();
          }
        })(marker, item));
        this.markers.push(marker)
      })
    }

    renderListLocation() {
      const locations = this.filterLocations()
      this.list.innerHTML = ''
      this.resultsCount.innerHTML = `${locations.length} Result${locations.length === 1 ? '' : 's'}`
      if (locations && locations.length) {
        const currentLocation = this.loc && this.loc.lat ? this.loc : window.locations.default_location
        locations.sort((a, b) => {
          var aDistance = this.calcCrow(currentLocation.lat, currentLocation.lng, a.latitude, a.longitude)
          var bDistance = this.calcCrow(currentLocation.lat, currentLocation.lng, b.latitude, b.longitude)
          return aDistance - bDistance
        })
        locations.forEach(item => {
          try {
            const locationHtml = `
              <div class="location ${item.externalId === Number(this.prefLocation) ? 'location--preferred' : ''}" data-location data-id="${item.externalId}">
                <div class="location__header">
                  ${this.renderTitle(item)}
                  ${this.renderDistance(item)}
                </div>
                ${this.renderSpecialties(item)}
                <div class="location__meta">
                  ${this.renderPhone(item)}
                  ${this.renderAddress(item)}
                </div>
                <div data-location-pref-status>
                  ${this.renderPreferredClinic(item)}
                  ${this.renderMakePreferred(item)}
                </div>
                <div class="location__actions">
                  ${this.renderBookingButton(item)}
                  ${this.renderDetailsButton(item)}
                </div>
              </div>
            `
            this.list.innerHTML += locationHtml
          } catch (e) {
            console.error('Error rendering location:', item.externalId, e)
          }
        })
      } else {
        const locationHtml = `
          <div class="location location--no-locations text-center">
            <div class="location__title">
              ${window.locations.text.no_locations}
            </div>
          </div>
        `
        this.list.innerHTML = locationHtml
      }
    }

    renderTitle(item) {
      const webpage = window.location.pathname.includes('/en/') ? item.webpageEn : item.webpageFr
      if (window.location.host === 'web.uat.fyidoctors.com' || window.location.host === 'visique-dev.myshopify.com') {
        try {
          const { pathname, host } = new URL(webpage)
          const newHost = host === 'visique.com' ? 'visique-dev.myshopify.com' : 'web.uat.fyidoctors.com'
          const newUrl = `https://${newHost}${pathname}`
          return `
            <h2 class="location__title" data-id="${item.name}">
              <a href="${newUrl}">
                ${item.name}
              </a>
            </h2>
          `
        } catch (e) {
          // Fall through to default if URL is invalid
        }
      }
      return `
        <h2 class="location__title" data-id="${item.name}">
          <a href="${webpage || '#'}">
            ${item.name}
          </a>
        </h2>
      `
    }

    renderAddress(item) {
      return `
        <div class="location__address">
          <p class="location__street-address">
            ${item.addressLine1},
          </p>
          <span class="location__city">
            ${item.city ? item.city : ''}${!item.province ? '' : ','}
          </span>
          <span class="location__province">
            ${item.province ? item.province : ''}
          </span>
        </div>
      `
    }

    renderDistance(item) {
      if (localStorage.getItem("geoperm") == "false") { return '' }
      if (isNaN(Number(this.calcCrow(this.loc.lat, this.loc.lng, item.latitude, item.longitude)))) { return '' }
      return `
          <span class="location__distance">
            ${parseInt(this.calcCrow(this.loc.lat, this.loc.lng, item.latitude, item.longitude)) + 'km'}
          </span>
        `
    }

    renderSpecialties(item) {
      if (!item.specialties) { return '' }
      return `
          <div class="location__badges">
            <div class="location__badge">
              ${item.specialties}
            </div>
          </div>
        `
    }

    renderPhone(item) {
      if (!item.phoneNumber) { return '' }
      return `
          <div class="location__phone" data-id="${item.phoneNumber}">
            <a href="tel:${item.phoneNumber}">
              ${formatPhoneNumber(item.phoneNumber)}
            </a>
          </div>
        `
    }

    renderPreferredClinic(item) {
      if (item.externalId != this.prefLocation || !window.locations.is_customer) { return '' }
      return `
          <div class="location__pref-clinic">
            <span class="location__pref-clinic-label">${window.locations.text.preferred_clinic}</span>
          </div>
        `
    }

    // For UAT hard-coded BonLook locations only
    isBonLookOverride(item) {
      const bonLookIds = [4531, 4532, 4533, 4534, 4535, 4536, 4537, 604, 605, 606, 607]
      return bonLookIds.includes(Number(item.externalId))
    }

    renderBookingButton(item) {
      if (item.consortium === 'Solis Optics') { return '' }
      if (this.isBonLookOverride(item)) { return '' } // For UAT
      if (item.consortium === 'BonLook') {
        return `
        <a id="bookingButton" href="${window.location.pathname.includes('/fr/') ? item.webpageFr : item.webpageEn}" class="btn btn--secondary">
          ${window.locations.text.book_appointment}
        </a>
        `
      }

      const isFyi = item.consortium.toUpperCase() == 'FYIDOCTORS'
      const enabled = item.webSchedulerEnabled
      const clinicId = String(item.externalId)

      // Visique merged/closed clinics -> hide booking button entirely
      if (!isFyi && this.visiqueHiddenBookingIds.includes(clinicId)) { return '' }

      // FYi without scheduler -> show "Call to Book" linking to the clinic phone (tel:)
      // Falls back to non-clickable text if no phone number is on file.
      if (isFyi && !enabled) {
        const phone = item.phoneNumber ? item.phoneNumber.replace(/\D/g, '') : ''
        return phone
          ? `<a href="tel:${phone}" class="btn btn--secondary">Call to Book</a>`
          : `<a class="btn btn--secondary">Call to Book</a>`
      }

      const apptUrl = isFyi
        ? 'https://fyidoctors.com/pages/book-an-appointment?locationId='
        : enabled
          ? 'https://visique.com/pages/rendez-vous?locationId='
          : 'https://visique.com/pages/demander-un-rendez-vous?locationId='
      let newUrl = apptUrl
      if (window.location.host === 'web.uat.fyidoctors.com' || window.location.host === 'visique-dev.myshopify.com') {
        const { host } = new URL(apptUrl)
        const newHost = host === 'visique.com' ? 'visique-dev.myshopify.com' : 'web.uat.fyidoctors.com'
        newUrl = apptUrl.replace(host, newHost)
      }
      return `
        <a id="bookingButton" href="${newUrl}${item.externalId}" class="btn btn--secondary">
          ${window.locations.text.book_appointment}
        </a>
      `
    }

    appendCurrentParams(url) {
      const currentParams = new URLSearchParams(window.location.search)
      if (!currentParams.toString() || !url || url === '#') { return url }
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}${currentParams.toString()}`
    }

    appendUtmSource(url) {
      const utmSource = new URLSearchParams(window.location.search).get('utm_source')
      if (!utmSource || !url || url === '#') { return url }
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}utm_source=${encodeURIComponent(utmSource)}`
    }

    renderDetailsButton(item) {
      if (item.consortium === 'Solis Optics' && item.webpageEn === null) {
        const solisUrl = this.appendCurrentParams('https://www.solisoptics.ca/')
        return `
          <a href="${solisUrl}" class="btn btn--primary btn--outline">
            ${window.locations.text.view_details}
          </a>
        `
      }
      if (this.isBonLookOverride(item)) {
        const bonlookUrl = this.appendCurrentParams('https://bonlook.ca')
        return `
          <a href="${bonlookUrl}" class="btn btn--primary btn--outline">
            ${window.locations.text.view_details}
          </a>
        `
      }
      const webpage = window.location.pathname.includes('/fr/') ? item.webpageFr : item.webpageEn
      if (window.location.host === 'web.uat.fyidoctors.com' || window.location.host === 'visique-dev.myshopify.com') {
        try {
          const { host } = new URL(webpage)
          const newHost = host === 'visique.com' ? 'visique-dev.myshopify.com' : 'web.uat.fyidoctors.com'
          const newUrl = this.appendUtmSource(webpage.replace(host, newHost))
          return `
            <a href="${newUrl}" class="btn btn--primary btn--outline">
              ${window.locations.text.view_details}
            </a>
          `
        } catch (e) {
          // Fall through to default if URL is invalid
        }
      }
      return `
        <a href="${this.appendUtmSource(webpage || '#')}" class="btn btn--primary btn--outline">
          ${window.locations.text.view_details}
        </a>
      `
    }

    renderMakePreferred(item) {
      if (!window.locations.is_customer || item.externalId === Number(this.prefLocation)) { return '' }
      return `
        <location-pref-button class="location__make-preferred-wrapper" data-location-id="${item.externalId}">
          <button
            type="button"
            class="location__make-preferred"
            data-prefer-this-location
          >
            ${window.locations.text.make_preferred_clinic}
          </button>
        </location-pref-button>
      `
    }

    filterLocations() {
      const center = this.map.getCenter()
      // const selectedConsortiums = [...this.consortiumCheckboxes]
      //   .filter(cb => cb.checked)
      //   .map(cb => cb.value.toLowerCase())
      let locations = this.allLocations

      locations = locations.filter(item =>
        item.consortium !== 'Solis Optics' && item.consortium !== 'BonLook'
      )

      // if (this.manulifeCheckbox?.checked && this.manulifeLocationIds.length) {
      //   locations = locations.filter(item =>
      //     this.manulifeLocationIds.includes(String(item.externalId)) ||
      //     (item.consortium && item.consortium.toLowerCase() === 'bonlook')
      //   )
      // }

      // if (selectedConsortiums.length) {
      //   locations = locations.filter(item =>
      //     item.consortium && selectedConsortiums.includes(item.consortium.toLowerCase())
      //   )
      // }

      if (!center) { return locations }
      return locations.filter(item => {
        return this.calcCrow(center.lat(), center.lng(), item.latitude, item.longitude) <= this.range / 1000
      })
    }

    handleOptionalRedirect() {
      const urlParams = new URLSearchParams(window.location.search);
      const r = urlParams.get('continueTo');

      if (r) {
        setTimeout(() => {
          window.location.href = r.replace("%2F", "?").replace("%3D", "=");
        }, 1000);
      }
    }

    toRad(value) {
      return value * Math.PI / 180;
    }

    calcCrow(lat1, lon1, lat2, lon2) {
      var R = 6371; // km
      var dLat = this.toRad(lat2 - lat1);
      var dLon = this.toRad(lon2 - lon1);
      var lat1 = this.toRad(lat1);
      var lat2 = this.toRad(lat2);

      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    }

    updatePreferredClinic(locationID, parentEl) {
      const token = localStorage.getItem('LRTokenKey');
      const body = JSON.stringify({ 'locationId': locationID });

      fetch(`${window.locations.api_url}/customer/preferred-clinic`, {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json; charset=utf-8"
        },
        body: body
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error("Request failed")
          }
        })
        .then(result => {
          var data = result.locationId
          localStorage.setItem('pc', data)
          this.prefLocation = data
          this.removeOldPreferredLocationEl()
          this.updatePreferredLocationEl(locationID, parentEl)
          this.renderMarkers()
          setTimeout(() => {
            this.handleOptionalRedirect()
          }, 50)
        })
        .catch(error => {
          console.error(error)
        })
    }

    removeOldPreferredLocationEl() {
      const oldPrefLocation = [...this.querySelectorAll('[data-location]')].find(location => location.classList.contains('location--preferred'))
      if (!oldPrefLocation) { return }
      const item = this.allLocations.find(location => location.externalId === Number(oldPrefLocation.dataset.id))
      const prefEl = oldPrefLocation.querySelector('[data-location-pref-status]')

      oldPrefLocation.classList.toggle('location--preferred', item.externalId === Number(this.prefLocation))
      prefEl.innerHTML = `
        ${this.renderPreferredClinic(item)}
        ${this.renderMakePreferred(item)}
      `
    }

    updatePreferredLocationEl(locationID, parentEl) {
      console.log('this.allLocations', this.allLocations)
      const item = this.allLocations.find(location => location.externalId === Number(locationID))
      const prefEl = parentEl.querySelector('[data-location-pref-status]')

      prefEl.innerHTML = `
        ${this.renderPreferredClinic(item)}
        ${this.renderMakePreferred(item)}
      `
      parentEl.classList.toggle('location--preferred', item.externalId === Number(this.prefLocation))
    }

    async initMap(locationCenter = window.locations.default_location) {
      this.map = new google.maps.Map(this.mapEl, {
        center: locationCenter,
        zoom: 10,
        mapTypeControl: false, // Hide the Satellite view toggle
        streetViewControl: false, // Hide the Street View option
        fullscreenControl: false, // Hide the Fullscreen option
      })

      try {
        const res = await fetch(window.locations.map_json_url)
        if (!res.ok) { throw new Error(res.statusText) }

        const data = await res.json()
        this.map.setOptions({ styles: data })
      } catch (err) {
        console.error(err)
      }

      this.map.addListener('center_changed', () => {
        if (Date.now() > (this.clickTime + 1000)) {
          this.renderMarkers()
          this.renderListLocation()
        }
      })
    }
  })
})();

(() => {
  if (typeof window.customElements.get('location-pref-button') !== 'undefined') { return }
  window.customElements.define('location-pref-button', class LocationsPrefButton extends HTMLElement { // eslint-disable-line
    constructor() {
      super()
      this.button = this.querySelector('[data-prefer-this-location]')
      this.parentList = this.closest('locations-section')
      this.init()
    }

    init() {
      if (!this.button || !this.parentList) { return }
      this.button.addEventListener('click', () => {
        const parentEl = this.closest('[data-location]')
        this.parentList.updatePreferredClinic(this.dataset.locationId, parentEl)
      })
    }
  })
})();
